<template>
	<MStateBox :loading="investment_activity.loading" :empty="isEmpty">
		<div class="activity-wrapper">
			<div
				v-for="(item, index) in getActivityList"
				:key="index"
				class="activity-item"
				:class="{ 'activity-item--border': useBorder }"
			>
				<div class="activity-icon">
					<el-image :src="actIconImgList[index]" fit="cover" />
					<MixColorMask />
				</div>
				<div class="activity-title mt-20 text-overflow3">{{ item.title }}</div>
				<div class="activity-other">
					<div class="activity-footer mt-20">
						<div class="activity-date">{{ dateFormatYearMonthDate(item.date) }}</div>
						<div class="activity-more" @click="handleClick(item)">
							<div>{{ $t('enterprise.view-details') }}</div>
							<i class="iconfont icon-flip-right"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</MStateBox>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';
import { useCommonData } from '@/hooks';
import MStateBox from '@rebuild/components/MStateBox.vue';
import { dateFormatYearMonthDate } from '@/utils/format';
import { useCurrentContext, useCurrentReactive } from './context';


const context = useCurrentContext();
const useBorder = computed(() => context.useBorder);

const { investment_activity, isEmpty, getActivityList, viewActivity, refreshComponent } = useCurrentReactive();
const handleClick = item => viewActivity(item);

const actIconImgList = ref([]);
const { getUpperThemeColor } = useCommonData();
watch(
	() => getUpperThemeColor.value,
	() => {
		actIconImgList.value = context.coverListInFlow;
	},
	{ immediate: true }
);


onMounted(async () => {
	refreshComponent();
});
</script>

<style lang="less" scoped>
.activity {
	&-wrapper {
		display: flex;
		justify-content: space-between;
	}
	&-item {
		flex: 1;
		height: 216px;
		background: #fff;
		padding: 24px;
		box-sizing: border-box;
		position: relative;
		display: flex;
		justify-content: space-between;
		flex-direction: column;

		& + .activity-item {
			margin-left: 14px;
		}

		&--border {
			border: 1px solid var(--border-lighter-color);
			border-radius: 2px;
		}
	}
	&-icon {
		position: absolute;
		top: 24px;
		right: 24px;
		width: 72px;
		height: 72px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	&-title {
		color: #1d2129;

		font-size: 16px;

		font-weight: 500;
		line-height: 140%; /* 22.4px */
		width: 239px;
		word-break: keep-all !important;
	}
	&-other {
		.activity-desc {
			color: #86909c;

			font-size: 12px;

			font-weight: 400;
			line-height: 140%; /* 16.8px */
			width: 320px;
		}
	}
	&-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	&-date {
		color: #4e5969;

		font-size: 14px;

		font-weight: 400;
		line-height: 16px; /* 114.286% */
	}
	&-more {
		padding: 0 12px;
		height: 32px;
		display: flex;
		align-items: center;
		background: var(--theme-color-gradient-010);
		cursor: pointer;
		color: #4e5969;

		font-size: 14px;

		font-weight: 400;

		.iconfont {
			font-size: 16px;
		}
	}
}
</style>
